
<app-warning-icon></app-warning-icon>

<router-outlet></router-outlet>

<ngx-spinner
  bdColor="rgba(0,0,0,0.5)"
  size="medium"
  color="#fff"
  type="ball-scale-multiple"
  [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>
